// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-surveillance-technology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-surveillance-technology/atc-surveillance-technology.js';

mount([g0]);
